import React from "react";

const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function formatRemaining(minutes) {
  const safe = Math.max(0, minutes);
  const h = Math.floor(safe / 60);
  const m = safe % 60;
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} hr`;
  return `${h} hr ${m} min`;
}

function toMinutes(time) {
  const [h, m] = time.split(".").map(Number);
  return h * 60 + (m || 0);
}

function OpenColseTime({ storeBusiness }) {
  const todayDay = DAYS[new Date().getDay()];
  const todayEntry = storeBusiness.find((hour) =>
    hour.days.includes(todayDay)
  );

  const now = new Date();
  const currentTimeValue = now.getHours() * 60 + now.getMinutes();

  if (!todayEntry) {
    return <span>Hours unavailable</span>;
  }

  const openValue = toMinutes(todayEntry.Opening);
  const closeValue = toMinutes(todayEntry.Closing);

  let status;
  let detail;
  if (currentTimeValue >= openValue && currentTimeValue <= closeValue) {
    status = "Open Now";
    detail = `Closes in ${formatRemaining(closeValue - currentTimeValue)}`;
  } else if (currentTimeValue < openValue) {
    status = "Closed Now";
    detail = `Opens in ${formatRemaining(openValue - currentTimeValue)}`;
  } else {
    status = "Closed Now";
    detail = `Opens tomorrow in ${formatRemaining(
      1440 - currentTimeValue + openValue
    )}`;
  }

  return (
    <div>
      <span className="openclose">{status}</span>
      <span> {detail}</span>
    </div>
  );
}

export default OpenColseTime;
